import { Pet } from '@app/models/pet.model'

export enum PET_ACTIONS {
	LOAD = '[Pet] Load',
	ADD_NEW = '[Pet] Add New',
	ADD = '[Pet] Add',
	UPDATE = '[Pet] Update',
	UPDATE_VET_VISIT = '[Pet] Update Vet Visit',
	UNSET_DATE_OF_BIRTH = '[Pet] Unset Date of Birth',
	ARCHIVE = '[Pet] Archive',
	UNARCHIVE = '[Pet] Unarchive',
	DELETE = '[Pet] Delete',
	RESET_COVERAGES = '[Pet] Reset Coverages',
	CLEAR = '[Pet] Clear',
}

export namespace PetAction {
	export class Load {
		static readonly type = PET_ACTIONS.LOAD
		constructor(public payload: Pet[]) {}
	}

	/** Used to add a new pet with a generated GUID if there are */
	export class AddNew {
		static readonly type = PET_ACTIONS.ADD_NEW
	}

	export class Add {
		static readonly type = PET_ACTIONS.ADD
		constructor(public payload: Partial<Pet>) {}
	}

	export class Update {
		static readonly type = PET_ACTIONS.UPDATE
		constructor(public payload: Partial<Pet>) {}
	}

	export class UpdateVetVisit {
		static readonly type = PET_ACTIONS.UPDATE_VET_VISIT
		constructor(public payload: 'true' | 'false') {}
	}

	export class UnsetDateOfBirth {
		static readonly type = PET_ACTIONS.UNSET_DATE_OF_BIRTH
		constructor(public payload: string) {}
	}

	export class Archive {
		static readonly type = PET_ACTIONS.ARCHIVE
		constructor(public payload: string) {}
	}

	export class Unarchive {
		static readonly type = PET_ACTIONS.UNARCHIVE
		constructor(public payload: string) {}
	}

	export class Delete {
		static readonly type = PET_ACTIONS.DELETE
		constructor(public payload: string) {}
	}

	export class ResetCoverages {
		static readonly type = PET_ACTIONS.RESET_COVERAGES
	}

	export class Clear {
		static readonly type = PET_ACTIONS.CLEAR
	}
}
